import { useQuery } from "@tanstack/react-query";
import type { InfoTopBannerType } from "@/features/top-banners/api/get-info-top-banner";

const useGetInfoTopBanners = () => {
  return useQuery({
    queryKey: ["info-top-banners"],
    queryFn: () =>
      fetch("/api/top-banners/info", {
        method: "GET",
      }).then((res) => res.json()) as Promise<{
        data: InfoTopBannerType[] | null;
      }>,
  });
};

export { useGetInfoTopBanners };
